import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CircledPlusIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 20"
      height={getDefaultHeight(svgProps, 20)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeWidth="1.5"
    >
      <path d="M10.5 6.3v7.4M6.8 10h7.4M10.5 19.3a9.3 9.3 0 1 0 0-18.6 9.3 9.3 0 0 0 0 18.6Z" />
    </SVG>
  );
};
